// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/user/routes/ForgotPassword/components/ForgotPassword/ForgotPassword.scss
// module id = 821
// module chunks = 0